// extracted by mini-css-extract-plugin
export default {"container":"footer_container__QH-jI","nameJapanese":"footer_nameJapanese__f0bqz","nameRomanji":"footer_nameRomanji__6vjMr"};